import cn from 'classnames';

import styles from './app-layout.module.scss';

const AppLayoutHeaderDivider: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ className, ...props }) => {
  return <div className={cn(styles.headerDivider, className)} {...props} />;
};

export default AppLayoutHeaderDivider;
